import { DefaultService } from "~/api/njorda";

export type {
  TOrganizationsResponse,
  TOrganization,
} from "~/interfaces/api";

export default function useOrganizationsApi() {
  return {
    getOrganizations: DefaultService.getB2BV1AdvisorOrganizations,
  };
}
